import axios from 'axios';
import { Language, QuestionsResponse, QuizSubmission } from '../types/quiz';
import { ProfileResult } from '../types/result';

const api = axios.create({
  baseURL:  '/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const getQuestions = async (language: Language): Promise<QuestionsResponse> => {
  const response = await api.get<QuestionsResponse>(`/quiz/questions`, {
    params: { language },
  });
  return response.data;
};

export const submitQuiz = async (submission: QuizSubmission): Promise<ProfileResult> => {
  const response = await api.post<ProfileResult>(`/quiz/submit`, submission);
  return response.data;
};
